var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"object-attribute"},[(_vm.props.data.value.value)?_c('div',[_c('i',{staticClass:"svg-calendar"}),_vm._v(" "+_vm._s(_vm.props.data.value.label)+" UTC ")]):_c(_vm.injections.components.EmptyValue,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }